import { Popup, PopupDisplay } from "../types/global";

// The same popup opens by itself again at the earliest this long after it last
// opened, and at most once per visit, until the admin's display count is used.
export const POPUP_REOPEN_GAP_MS = 6 * 60 * 60 * 1000;

// This player's display record for a popup. Records saved before counts were
// kept per player have no playerId and count for whoever plays.
export function popupDisplay(
  displays: PopupDisplay[] | undefined,
  popupId: number,
  playerId: number | undefined
): PopupDisplay | undefined {
  return displays?.find(
    (display) =>
      display?.popupId === popupId &&
      (display.playerId == null || display.playerId === playerId)
  );
}

const time = (value: string | null | undefined, fallback: number) => {
  if (!value) return fallback;
  const parsed = new Date(value).getTime();
  return Number.isNaN(parsed) ? fallback : parsed;
};

// The popups that may open by themselves now, earliest start first: active and
// within their dates (a missing date is open-ended), not turned off by the
// player, shown fewer times than the admin allows, not opened in the last
// POPUP_REOPEN_GAP_MS, and not already shown in this visit (`skip`).
export function duePopups(
  popups: Popup[] | undefined,
  displays: PopupDisplay[] | undefined,
  playerId: number | undefined,
  now: number,
  skip: ReadonlySet<number> = new Set()
): Popup[] {
  return (popups || [])
    .filter((popup) => {
      if (!popup || !popup.isActive || skip.has(popup.id)) return false;
      if (now < time(popup.startDate, -Infinity) || now > time(popup.endDate, Infinity)) return false;
      if (popup.dontShowAgain) return false;
      const display = popupDisplay(displays, popup.id, playerId);
      if (display?.dontShowAgain) return false;
      if ((display?.displayedCount || 0) >= (popup.displayCount || 0)) return false;
      if (display?.lastShownAt && now - display.lastShownAt < POPUP_REOPEN_GAP_MS) return false;
      return true;
    })
    .sort((a, b) => time(a.startDate, 0) - time(b.startDate, 0));
}
